import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import StandardFrontCard from '../SingleAction/SingleActionDetails';
import EmailDetails from './EmailDetails';
import EmailSuccess from './EmailSuccess';
import EmailDetailsMultiRepStep2 from './EmailDetailsMultiRepStep2';
import FindLocalRep from '../LocalRep/FindLocalRep';

const StartCard = StandardFrontCard('email');
const EmailDetailsCard = EmailDetails('email','/email');
const EmailDetailsMultiRepStep2Card = EmailDetailsMultiRepStep2('email','/email/multiRepStep2');

const Email = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/email/start"
                            name="EmailStart"
                            exact
                            component={StartCard}
                        />
                        <Route
                            path="/email"
                            name="EmailDetails"
                            exact
                            component={EmailDetailsCard}
                        />
                        <Route
                            path="/email/multiRepStep2"
                            name="EmailDetailsMultiRepStep2"
                            exact
                            component={EmailDetailsMultiRepStep2Card}
                        />
                        <Route
                            path="/email/success"
                            name="EmailSuccess"
                            exact
                            component={EmailSuccess}
                        />
                        <Route
                            path="/email/findRep"
                            name="EmailFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Email;
